<button mat-icon-button aria-label="restore"
    (click)="restoreAndGoToFirstScheduling(element)">
    <mat-icon color="primary"> restore_from_trash </mat-icon>
</button>